<template>
	<trumbowyg
		v-model="body"
		:config="config"
		:disabled="disabled"
		@input="$emit('input', body)"
	/>
</template>

<script>
export default {

	props: {
		value: {
			type: String,
			required: false,
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	data ()
	{
		return {
			body: this.value,
			config: {
				btns: ['bold', 'italic', 'unorderedList'],
				lang: 'de',
				svgPath: '/img/trumbowyg-icons.svg',
				autogrow: true,
				removeformatPasted: true,
				btnsDef: {
					bold: {
						title: 'Fett'
					},
					italic: {
						title: 'Kursiv'
					},
					unorderedList: {
						title: 'Aufzählungszeichen'
					},
				}
			}
		};
	}
}
</script>
